import React, { useRef, useState } from "react";
import { FormGroup, Label, Button } from "reactstrap";

const Foto = ({ fotoRumah, setFotoRumah, imagePreview, setImagePreview, isPreviewing, setIsPreviewing }) => {
    const videoRef = useRef(null);

    const startPreview = async () => {
        setIsPreviewing(true);
        const stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: "environment" }, // Kamera belakang
        });
        videoRef.current.srcObject = stream;
        await videoRef.current.play();
    };
    const capturePhoto = async () => {
        const canvas = document.createElement("canvas");
        canvas.width = videoRef.current.videoWidth;
        canvas.height = videoRef.current.videoHeight;
        canvas.getContext("2d").drawImage(videoRef.current, 0, 0);
    
        const dataUrl = canvas.toDataURL("image/png");
        const blob = await fetch(dataUrl).then((res) => res.blob());
        setFotoRumah(new File([blob], "captured-photo.png", { type: "image/png" }));
        setImagePreview(dataUrl);
    
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
        setIsPreviewing(false);
      };
    
      // Hapus foto yang telah diunggah/dicapture
      const cancelPreview = () => {
        setImagePreview(null);
        setFotoRumah(null);
        if (isPreviewing) {
          videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
        }
        setIsPreviewing(false);
      };
    
      // Menyimpan foto dari file input
      const handlePhotoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = () => {
            setImagePreview(reader.result);
            setFotoRumah(file);
          };
          reader.readAsDataURL(file);
        }
      };
  return (
    <FormGroup>
      <Label for="fotoRumah">Upload Foto Tanah</Label>
      
      {/* Input untuk unggah foto dari galeri */}
      <input 
        type="file" 
        name="fotoRumah" 
        id="fotoRumah" 
        accept="image/*" 
        onChange={handlePhotoChange}
        style={{ display: "none" }}
      />

      {/* Tombol untuk membuka kamera */}
      {isPreviewing ? (
        <div>
          <video ref={videoRef} style={{ width: "100%", height: "auto" }} />
          <Button className="btn btn-primary mt-2" onClick={capturePhoto}>
            Ambil Foto
          </Button>
        </div>
      ) : (
        <div className="d-flex gap-2">
          <Button className="btn btn-primary mt-2 flex-fill" onClick={startPreview}>
            Gunakan Kamera
          </Button>
          <Button 
            className="btn btn-secondary mt-2" 
            onClick={() => document.getElementById("fotoRumah").click()}
          >
            📁 Pilih dari Galeri
          </Button>
        </div>
      )}

      {/* Preview gambar yang diunggah atau ditangkap */}
      {imagePreview && (
        <div className="mt-3">
          <img src={imagePreview} alt="Preview" style={{ width: "100%", maxHeight: "300px", objectFit: "contain" }} />
          <Button className="btn btn-danger mt-2" onClick={cancelPreview}>
            Hapus Foto
          </Button>
        </div>
      )}
    </FormGroup>
  )
}

export default Foto